const initialCacheData = {};

export default initialCacheData;
